import styled from "styled-components";
import { colors } from "../../../../styles/colors";

export const RatingSectionContainer = styled.div`
  padding: 15px;
  border: 0.5px solid ${colors.lightBlueGrayAlpha40};
  border-radius: 9px;

  .rating-text-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    padding-bottom: 15px;
    border-bottom: 0.5px solid ${colors.lightBlueGray};

    .rating-title {
      font-size: 16px;
      line-height: 16px;
      letter-spacing: -0.22px;
      color: ${colors.darkBlue};

      @media (max-width: 768px) {
        max-width: 45px;
      }
    }
    .rating-value {
      font-size: 40px;
      line-height: 40px;
      color: ${colors.darkBlue};
    }
  }
  .rating-count {
    margin-top: 15px;
    font-size: 16px;
    color: ${colors.blueGray};
    text-align: center;
  }
`;
